import { getAmplitudeInstance } from '../amplitudeHelpers';
import BottomNavTabName from '../enums/BottomNavTabName';
import CardLocation from '../enums/CardLocation';

type logActivityCardClickedParams = {
  detailed_card_location?: CardLocation;
  map_id: string;
  owned_by_user?: boolean;
  owner_id?: string;
  tab_location?: BottomNavTabName;
};

/**
 * activity card was clicked by the user
 * @param params - Attributes to log with the amplitude event
 * @param params.detailed_card_location - Detailed location in the app where the activity card was clicked.
 * @param params.map_id - map id of the activity that was clicked by the user
 * @param params.owned_by_user - Whether the screen is associated a first party or third party user
 * @param params.owner_id - User ID of the content owner
 * @param params.tab_location - a string representing the tab where the Activities tab is located
 */
const logActivityCardClicked = (
  { detailed_card_location, map_id, owned_by_user, owner_id, tab_location }: logActivityCardClickedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'activity card clicked',
    {
      'detailed card location': detailed_card_location,
      'map id': map_id,
      'owned by user': owned_by_user,
      'owner id': owner_id,
      'tab location': tab_location
    },
    callback
  );
};

export default logActivityCardClicked;
